import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import realtimeConsultationTranslations from './locales/realtimeConsultations';
import { DEFAULT_UI_LOCALE, normalizeUiLocale, SUPPORTED_LOCALES } from './utils/locale';

import translationEN from './locales/en-US/translation.json';
import translationAR from './locales/ar-SA/translation.json';
import translationZHCN from './locales/zh-CN/translation.json';
import translationZHHK from './locales/zh-HK/translation.json';
import translationZHTW from './locales/zh-TW/translation.json';
import translationZHMO from './locales/zh-MO/translation.json';
import translationVI from './locales/vi-VN/translation.json';
import translationTH from './locales/th-TH/translation.json';
import translationID from './locales/id-ID/translation.json';
import translationMS from './locales/ms-MY/translation.json';
import translationRU from './locales/ru-RU/translation.json';

const resources = {
  'en-US': { translation: translationEN },
  'ar-SA': { translation: translationAR },
  'zh-CN': { translation: translationZHCN },
  'zh-HK': { translation: translationZHHK },
  'zh-TW': { translation: translationZHTW },
  'zh-MO': { translation: translationZHMO },
  'vi-VN': { translation: translationVI },
  'th-TH': { translation: translationTH },
  'id-ID': { translation: translationID },
  'ms-MY': { translation: translationMS },
  'ru-RU': { translation: translationRU },
};

const storageKey = 'i18nextLng';
Object.entries(resources).forEach(([locale, resource]) => {
  resource.translation = { ...resource.translation, realtimeConsultations: realtimeConsultationTranslations[locale] };
});
if (typeof window !== 'undefined') {
  try {
    const storedLocale = window.localStorage.getItem(storageKey);
    if (storedLocale) {
      window.localStorage.setItem(storageKey, normalizeUiLocale(storedLocale));
    }
  } catch (_error) {
    // Language detection still falls back to the browser locale when storage is unavailable.
  }
}

i18n
  // 检测用户语言
  .use(LanguageDetector)
  // 传递i18n实例给react-i18next
  .use(initReactI18next)
  // 初始化i18next
  .init({
    resources,
    fallbackLng: DEFAULT_UI_LOCALE,
    supportedLngs: SUPPORTED_LOCALES.map(({ code }) => code),
    nonExplicitSupportedLngs: false,
    load: 'currentOnly',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      convertDetectedLanguage: normalizeUiLocale,
    }
  });

export { resources };
export default i18n;
